const IS_LOADING = "list/lists_rights/IS_LOADING";
const IS_ERROR = "list/lists_rights/IS_ERROR";
const DATA = "list/lists_rights/DATA";
export { IS_LOADING, IS_ERROR, DATA };
